import React, { Component } from "react";
import PropTypes from "prop-types";
import ChipInput from "./chipinput";
import {
  RestClient,
  RestApiProductList,
  RestApiCollectionMarketers
} from "../../../../../restClient";
import { GET_LIST } from "admin-on-rest";
const dataSourceConfig = { text: "text", value: "value" };

class ProductListInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      values: [],
      dataItems: [],
      productsContent: []
    };
    // console.log(props.marketerId);
    // console.log(props.typePage);
    if (props.typePage === "marketers") {
      this.getCollectionMarketer();
    } else {
      this.getCollections();
    }

    this.getProductList();
  }

  getCollectionMarketer = () => {
    let newValue = [];
    if (Array.isArray(this.props.values)) {
      newValue = this.props.values;
    }
    RestApiCollectionMarketers(this.props.marketerId)
      .then(response => {
        return response.json();
      })
      .then(items => {
        // console.log(items);
        if (items && !items.message) {
          this.setState({
            dataItems: items,
            values: this.getChoicesForValues(newValue, items)
          });
        }
      })
      .catch(e => {
        // console.error(e);
      });
  };
  getCollections = () => {
    let newValue = [];

    if (Array.isArray(this.props.values)) {
      newValue = this.props.values;
    }
    RestClient(GET_LIST, "collections", {
      pagination: { page: 1, perPage: 1000 },
      sort: { field: "name", order: "ASC" },
      filter: {}
    })
      .then(items => {
        this.setState({
          dataItems: items.data,
          values: this.getChoicesForValues(newValue, items.data)
        });
      })
      .catch(e => {
        console.error(e);
      });
  };

  getProductList = () => {
    let newValue = [];
    if (Array.isArray(this.props.values)) {
      newValue = this.props.values;
    }
    let params = newValue.join();
    const url = "/products?collections=" + params;
    RestApiProductList(url)
      .then(response => {
        return response.json();
      })
      .then(items => {
        if (Array.isArray(items.products)) {
          this.setState({ productsContent: items });
        }
      })
      .catch(e => {
        console.error(e);
      });
  };

  handleAdd = newValue => {
    const values = [...this.state.values, newValue];
    this.setState({ values });
    let newCollections = values.map(o => o.value);
    this.props.onChangeList(newCollections);
  };

  handleDelete = newValue => {
    const values = this.state.values.filter(v => v.value !== newValue);
    this.setState({ values });
    let newCollections = values.map(o => o.value);
    this.props.onChangeList(newCollections);
  };

  getChoicesForValues = (values, choices = []) => {
    if (!values || !Array.isArray(values)) {
      throw Error("Value of SelectArrayChipInput should be an array");
    }
    return values
      .map(value => choices.find(c => c.id === value) || { value, text: value })
      .map(this.formatChoice);
  };
  formatChoices = choices => choices.map(this.formatChoice);
  formatChoice = choice => {
    return {
      value: choice.id,
      text: choice.name
    };
  };

  render() {
    return (
      <div>
        <ChipInput
          id="collections"
          value={this.state.values}
          onRequestAdd={this.handleAdd}
          onRequestDelete={this.handleDelete}
          dataSource={this.formatChoices(this.state.dataItems)}
          dataSourceConfig={dataSourceConfig}
          openOnFocus
          fullWidth={true}
        />
      </div>
    );
  }
}

ProductListInput.propTypes = {
  values: PropTypes.array,
  onChangeList: PropTypes.func.isRequired,
  typePage: PropTypes.string,
  marketerId: PropTypes.string
};

ProductListInput.defaultProps = {
  values: [],
  typePage: "",
  marketerId: "0"
};

export default ProductListInput;



// WEBPACK FOOTER //
// ./src/editor/layout/addons/props/components/ProductListInput.js